// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".b-page-title[data-v-490f9aa1] {\n  width: 1114px;\n  padding-top: 10px;\n  text-align: left;\n  margin: 0 auto;\n  display: flex;\n}\n.b-page-title > div p[data-v-490f9aa1],\n.b-page-title > div a[data-v-490f9aa1] {\n  font-size: 12px;\n  font-weight: 500;\n  color: #999999;\n  line-height: 17px;\n  display: inline-block;\n}\n.b-page-title > div p[data-v-490f9aa1] {\n  margin: 0 2px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
